import React, { useState, useEffect } from 'react';
import { Save, Loader2 } from 'lucide-react';
import { getData, setData } from '../services/storage';
import { Button } from '../components/Forms';

const DEFAULT = {
  siteLogo: '', favicon: '', seoTitle: '', seoDescription: '',
  ogImage: '', googleAnalytics: '', googleTagManager: '',
};

const Settings = () => {
  const [form, setForm] = useState(DEFAULT);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [success, setSuccess] = useState('');

  useEffect(() => {
    const data = getData('settings');
    if (data) setForm({ ...DEFAULT, ...data });
    setLoading(false);
  }, []);

  const handleChange = (key, value) => setForm(f => ({ ...f, [key]: value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    setSaving(true);
    setSuccess('');
    setData('settings', form);
    setSuccess('Settings saved successfully!');
    setTimeout(() => setSuccess(''), 3000);
    setSaving(false);
  };

  if (loading) return <div className="flex justify-center py-16"><Loader2 className="animate-spin text-purple-500" size={32} /></div>;

  const Field = ({ label, value, onChange, type = 'text', placeholder = '', isTextarea = false }) => (
    <div>
      <label className="block text-sm font-medium text-slate-700 mb-1.5">{label}</label>
      {isTextarea ? (
        <textarea value={value} onChange={(e) => onChange(e.target.value)} rows={3}
          className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:border-purple-500 focus:ring-2 focus:ring-purple-500/20 outline-none text-sm resize-none" placeholder={placeholder} />
      ) : (
        <input type={type} value={value} onChange={(e) => onChange(e.target.value)}
          className="w-full px-4 py-2.5 rounded-lg border border-slate-300 focus:border-purple-500 focus:ring-2 focus:ring-purple-500/20 outline-none text-sm" placeholder={placeholder} />
      )}
    </div>
  );

  return (
    <div>
      {success && <div className="bg-emerald-50 border border-emerald-200 text-emerald-700 px-4 py-3 rounded-lg text-sm mb-6">{success}</div>}

      <form onSubmit={handleSubmit} className="space-y-6">
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
          <h3 className="text-base font-semibold text-slate-800 mb-4">Branding</h3>
          <div className="grid sm:grid-cols-2 gap-6">
            <Field label="Website Logo URL" value={form.siteLogo} onChange={(v) => handleChange('siteLogo', v)} placeholder="/uploads/logo.png" />
            <Field label="Favicon URL" value={form.favicon} onChange={(v) => handleChange('favicon', v)} placeholder="/uploads/favicon.png" />
            <Field label="Open Graph Image URL" value={form.ogImage} onChange={(v) => handleChange('ogImage', v)} placeholder="/uploads/og-image.png" />
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
          <h3 className="text-base font-semibold text-slate-800 mb-4">SEO</h3>
          <div className="space-y-4">
            <Field label="SEO Meta Title" value={form.seoTitle} onChange={(v) => handleChange('seoTitle', v)} placeholder="SkyMuse Digital Marketing Agency" />
            <Field label="SEO Meta Description" value={form.seoDescription} onChange={(v) => handleChange('seoDescription', v)} isTextarea placeholder="Description for search engines..." />
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-slate-200 p-6">
          <h3 className="text-base font-semibold text-slate-800 mb-4">Analytics & Tracking</h3>
          <div className="space-y-4">
            <Field label="Google Analytics Code" value={form.googleAnalytics} onChange={(v) => handleChange('googleAnalytics', v)} placeholder="G-XXXXXXXXXX" />
            <Field label="Google Tag Manager Code" value={form.googleTagManager} onChange={(v) => handleChange('googleTagManager', v)} placeholder="GTM-XXXXXXX" />
          </div>
        </div>

        <div className="flex justify-end">
          <Button loading={saving} type="submit">
            <Save size={18} />
            Save Settings
          </Button>
        </div>
      </form>
    </div>
  );
};

export default Settings;
